<template>
    <div class="inline-block">

            <input id="toggle"
                    type="hidden"
                    :value="thevalue"
            />
              <button v-if="thevalue == 1" v-on:click="isSure = !isSure" class="rounded-full ml-3 pr-3 pl-2 py-1 text-xxs font-bold bg-gray-600 leading-base"><i aria-hidden="true" class="material-icons text-base leading-base align-bottom pl-0">power</i>Turn ON</button>
              <button v-else="thevalue == 0" v-on:click="isSure = !isSure" class="rounded-full ml-3 pr-3 pl-2 py-1 text-xxs font-bold bg-gray-600 leading-base"><i aria-hidden="true" class="material-icons text-base leading-base align-bottom pl-0">power</i>Turn OFF</button>
        
        <div v-if="!isSure" class="bg-red-600 text-white w-full p-3 absolute top-0 left-0 text-sm z-50" v-click-outside="onClickOutside">
              {{confirmtext}} <br>
              <button id="toggleSharing" @click="toggleSharing" type="submit" class="btn text-sm bg-white text-red-700 commitbutton mt-1 rounded px-3 py-1"><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i>Yes, Do It</button>
          </div>
    </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import axios from 'axios'

  export default {

        props: {
            content: '',
            route:'',
            confirmtext: {
              default: 'Are You Sure?',
            },
            thevalue: ''
        },

        data() {
          return {
            success: false,
            isSure: true,
            loaded: true,
            value: this.thevalue,
          }
        },
        directives: {
          clickOutside: vClickOutside.directive
        },
        
        methods: {
          onClickOutside (event) {
              this.isSure = !this.isSure
          },
          toggleSharing: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( "#toggleSharing").addClass( "loading" );
              axios.put(this.route,
                {
                    sharing: (this.thevalue)
                }
              ).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },
      }
</script>
